import { Children, FC, ReactNode } from 'react'

export type ReflowHalfItem = {
  key: string
  content: ReactNode
}

type ReflowHalfGridProps = {
  items: ReflowHalfItem[]
  className?: string
  gapClass?: string
  /** Bootstrap column classes for each slot (default: half width from md up). */
  columnClassName?: string
}

/** Packs visible half-width fields left-to-right; hidden neighbors do not leave gaps. */
export const ReflowHalfGrid: FC<ReflowHalfGridProps> = ({
  items,
  className,
  gapClass = 'g-4',
  columnClassName = 'col-12 col-md-6',
}) => {
  if (items.length === 0) return null
  return (
    <div className={['row', gapClass, 'align-items-start', className].filter(Boolean).join(' ')}>
      {items.map((item) => (
        <div key={item.key} className={columnClassName}>
          {item.content}
        </div>
      ))}
    </div>
  )
}

type ReflowCardRowProps = {
  className?: string
  children: ReactNode
}

/** Card columns in a row reflow when an earlier sibling card is not rendered. */
export const ReflowCardRow: FC<ReflowCardRowProps> = ({ className, children }) => {
  const slots = Children.toArray(children).filter((child) => child != null)
  if (slots.length === 0) return null
  return (
    <div className={['row', 'g-4', 'align-items-stretch', className].filter(Boolean).join(' ')}>
      {slots}
    </div>
  )
}
